export const subjectsForShowNotification = [
  'Your CSV file has been successfully processed.',
]
